module.exports = __webpack_public_path__ + "bc2c213d793101505a4017530c748255.svg";